// extracted by mini-css-extract-plugin
export default {"price":"m8-z","onSale":"n8-z","msrpLabelPrice":"o8-z","msrpLabel":"p8-z","originalPrice":"q8-z","percentOff":"r8-z"};